/**
 * Translate description: Index page for orders
 */

import { useEffect, useContext, useState } from 'react';

import { langByCode, useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';
import InfoContext from '../../context/InfoContext';
import AppProvider from '../../provider/AppProvider';

import Bread from '../../components/layout/BreadCrumbs';
import Title from '../../components/layout/Title';
import ModalDelete from '../../components/layout/ModalDelete';
import { AddButton } from '../../components/blocks/AddButton';
import Content from './components/Content';
import UploadButton from '../../components/UploadButton';

import { Typography, Alert } from '@mui/joy';
import { Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, Stack, Button, IconButton } from '@mui/joy';
import InfoIcon from '@mui/icons-material/Info';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { Crud } from '../../utils/crud';

const crud = new Crud('orders');

function _Index() {
  const { t } = useLanguageContext();

  const { setInfo } = useContext(InfoContext);
  const { setListItems } = useContext(AppContext);
  const { paginator, setPaginator } = useContext(AppContext);
  const { sorting } = useContext(AppContext);
  const { filter, setFilter } = useContext(AppContext);
  const { setLoading } = useContext(AppContext);
  const { currentLang } = useContext(AppContext);
  const [csvModal, setCsvModal] = useState(false);
  const [csvLog, setCsvLog] = useState();

  const loadTable = async () => {
    if (!filter?.lang) return;
    setLoading(true);
    let list = await crud.get({ paginator, sorting, filter })
    if (list.is_error) {
      setInfo({ type: 'danger', show: true, message: `${t('Error')}` });
      setTimeout(() => setInfo({ show: false }), 6000)
      setLoading(false);
      return;
    }
    setLoading(false);
    setListItems(list.data);
    setPaginator({ ...paginator, totalPages: list.pages });
  }

  useEffect(() => {
    if (currentLang) setFilter({ ...filter, lang: { id: langByCode(currentLang).id } })
  }, [currentLang]);

  useEffect(() => {
    loadTable();
  }, [paginator.currentPage, filter.lang?.id, filter.lang?.operator, filter.status?.id, filter.store?.value, sorting, filter.status?.value, filter.status_cpa, filter.date_range?.from, filter.date_range?.to]);

  const [isHiddenInfo, setIsHiddenInfo] = useState(false);

  useEffect(() => {
    // При загрузке компонента читаем из localStorage
    const shouldHide = localStorage.getItem('order_info_close') === 'true';
    setIsHiddenInfo(shouldHide);
  }, []);

  return (
    <>
      <Bread path={[{ name: t("Orders") }]} />
      <Title>
        <Typography level="h2" component="h1">{t("Orders")}</Typography>
        <AddButton label={t("New order")} to={`/orders/add`} />
      </Title>
      <Alert variant="soft" color="primary" startDecorator={<InfoIcon />} endDecorator={<UploadButton uploadUrl="orders/csvupload"
        onSuccess={(result) => {
          console.log("Файл успешно загружен:", result);
          setCsvModal(1);
          setCsvLog(result.result.map(v => {
            const clr = v.log_message === 'Store not found' ? '#C41C1C' : 'inherit';
            return `<span style="color:${clr}">${v.row} - ${v.log_message}</span>`
          }
          ).join('<br>'));
          loadTable();
        }}
        onError={(err) => {
          console.error("Ошибка загрузки:", err);
          setCsvModal(1);
          setCsvLog(err.message);
        }}
      />}>
        <div>
          <div>Вы можете импортировать заказы через csv файл</div>
          <Typography level="body-sm" color="primary">
            Перед загрузкой csv файла убедитесь, что он соответствует <a href={`${process.env.REACT_APP_TMBACK_URL}/api/orders/csvDemo`}>ожидаемому формату</a>
          </Typography>
        </div>
      </Alert>

      <Alert style={{ display: isHiddenInfo ? 'none' : 'flex' }} variant="soft" sx={{ alignItems: 'flex-start' }} color="warning" startDecorator={<InfoIcon />} endDecorator={
        <IconButton variant="soft" color='neutral' onClick={() => { localStorage.setItem('order_info_close', 'true'); setIsHiddenInfo(true); }}><CloseRoundedIcon /></IconButton>
      }>
        <div>
          <div>Внимание!</div>
          <Typography level="body-sm" color="warning">
            К заказу может быть привязана транзакция - в этом случае Вы не сможете удалить заказ!
            <br />
            Чтобы скрыть заказ из кабинета пользователя - снимите его с публикации.
            <br />
            Если заказу присвоить статус approved - к нему автоматически привяжется транзакция начисления кэтчерсов.
            <br />
            Если заказу присвоить статус declined - к нему автоматически привяжется транзакция списания кэтчерсов.
          </Typography>
        </div>
      </Alert>
      <Content />
      <ModalDelete />

      <Modal open={csvModal}>
        <ModalDialog variant="plain">
          <ModalClose onClick={() => setCsvModal(false)} />
          <DialogTitle>CSV import result</DialogTitle>
          <Stack spacing={2} sx={{ maxHeight: '80vh', overflow: 'auto' }}>
            <div dangerouslySetInnerHTML={{ __html: csvLog }}></div>
          </Stack>
          <Button type="submit" onClick={() => setCsvModal(false)}>Close</Button>
        </ModalDialog>
      </Modal>
    </ >
  );
}

export default function Index() {
  return (
    <AppProvider>
      <_Index />
    </AppProvider>
  );
}